import React, { useEffect } from "react";

const Approach = () => {
  useEffect(() => {
    document.title = "Our Approach - EAP Finance";
  }, []);

  return (
    <div className="bg-[#fff] overflow-x-hidden">
      <section className="relative pt-[8rem]">
        <div className="relative px-6 md:px-12 lg:px-20 pb-10">
          {/* Decorative Image */}
          <div className="absolute inset-0 flex justify-center items-center z-0">
            <img
              src="https://cdn.prod.website-files.com/637b8553d2b3433e9297cdb4/63bfdb147093626ba9d65cfa_S.svg"
              alt="Decorative S"
              className="w-72 h-72 opacity-10"
              loading="lazy"
            />
          </div>

          {/* Heading */}
          <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-center mb-6 relative z-10 text-[#000300]">
            Our Collaborative Path to Your Financial Success
          </h1>

          {/* Introduction Paragraph */}
          <p className="text-[#000300] text-base md:text-lg leading-relaxed text-center mb-12 relative z-10 max-w-3xl mx-auto">
            EAP Finance operates on principles of transparency, expertise, and personalized partnership. Discover how we work with every client to achieve optimal financial outcomes.
          </p>

          {/* Content Sections */}
          <div className="relative z-10 max-w-4xl mx-auto space-y-12">
            {/* Our Process Section */}
            <div>
              <h2 className="text-2xl font-bold mb-6 text-[#000300]">Our Process</h2>
              <p className="text-[#000300] text-base mb-8">
                We follow a structured approach to ensure that our clients receive the best possible guidance and support. Here's an overview of our process:
              </p>
              
              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-semibold text-[#000300]">Step 1: Initial Discovery & Consultation</h3>
                  <p className="text-[#000300] text-base">
                    We begin with a confidential, in-depth discussion to understand your unique financial objectives, whether they are personal wealth goals or business capital needs.
                  </p>
                </div>
                
                <div>
                  <h3 className="text-lg font-semibold text-[#000300]">Step 2: Tailored Strategy Development</h3>
                  <p className="text-[#000300] text-base">
                    Our expert team conducts a thorough analysis of your financial landscape or business proposition, crafting a bespoke strategy aligned with your specific aspirations.
                  </p>
                </div>
                
                <div>
                  <h3 className="text-lg font-semibold text-[#000300]">Step 3: Solution Execution & Partnership</h3>
                  <p className="text-[#000300] text-base">
                    We leverage our extensive network to connect you with the most suitable investment opportunities, capital providers, or financial instruments, guiding you through every step of the execution phase.
                  </p>
                </div>
                
                <div>
                  <h3 className="text-lg font-semibold text-[#000300]">Step 4: Ongoing Support & Relationship</h3>
                  <p className="text-[#000300] text-base">
                    Our commitment extends beyond the immediate transaction. We aim for long-term partnerships, providing continued guidance and support as your financial journey evolves.
                  </p>
                </div>
              </div>
            </div>

            {/* Partnering for Success Section */}
            <div>
              <h2 className="text-2xl font-bold mb-6 text-[#000300]">Partnering for Success: What We Seek in Our Clients</h2>
              <p className="text-[#000300] text-base mb-8">
                While every client's situation is unique, our most successful partnerships are built on shared foundations. We look for:
              </p>
              
              <ul className="space-y-4">
                <li className="text-[#000300] text-base">
                  <span className="font-semibold">Clear Vision:</span> A well-defined financial goal or business objective.
                </li>
                <li className="text-[#000300] text-base">
                  <span className="font-semibold">Sound Financial Footing:</span> Demonstrated financial responsibility or a robust business model with strong fundamentals.
                </li>
                <li className="text-[#000300] text-base">
                  <span className="font-semibold">Readiness for Growth:</span> An openness to strategic guidance and a commitment to achieving significant milestones.
                </li>
                <li className="text-[#000300] text-base">
                  <span className="font-semibold">Transparency & Trust:</span> A willingness to share necessary information to build a trusting and productive partnership.
                </li>
                <li className="text-[#000300] text-base">
                  <span className="font-semibold">Scale of Ambition:</span> We primarily work with those seeking significant financial advancement or substantial capital for their projects/businesses.
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Separator */}
        <div className="w-full h-[2px] bg-gray-200 mt-8"></div>
      </section>
    </div>
  );
};

export default Approach;